import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { BehandlerAssignmentData } from '../model/behandler-assignment-data.interface';

@Injectable({
  providedIn: 'root',
})
export class BehandlerAssignmentService {
  readonly behandlerAssignmentChanged = new Subject<string>();

  getBehandlerAssignmentData(documentId: string): BehandlerAssignmentData | null {
    const value = localStorage.getItem(`assigned-behandler-${documentId}`);

    if (value) {
      return JSON.parse(value);
    }

    return null;
  }

  assignBehandler(documentId: string, data?: BehandlerAssignmentData) {
    const key = `assigned-behandler-${documentId}`;

    if (data) {
      localStorage.setItem(key, JSON.stringify(data));
    } else {
      localStorage.removeItem(key);
    }

    this.behandlerAssignmentChanged.next(documentId);
  }
}
